import {FC} from 'react';
import {useIsMaxSm} from 'features/auth/ui/AuthorizationSteps/useIsMaxSm';
import {Drawer} from 'shared/ui/Drawer';
import {getHowToBecomeContent, RegistrationWorkStatus} from '../../../model';
import {RegistrationButton} from '../RegistrationButton/RegistrationButton';
import infoStyles from '../WorkStatusesInfoDrawer/WorkStatusesInfoDrawer.module.css';
import styles from './HowToBecomeStatusDrawer.module.css';

type Props = {
	open: boolean;
	workStatus: RegistrationWorkStatus | null;
	onClose: () => void;
};

export const HowToBecomeStatusDrawer: FC<Props> = ({open, workStatus, onClose}) => {
	const isMaxSm = useIsMaxSm();
	const content = getHowToBecomeContent(workStatus);

	const openExternal = (url: string) => {
		window.open(url, '_blank', 'noopener,noreferrer');
	};

	return (
		<Drawer
			open={open}
			onClose={onClose}
			title={content.title}
			showCloseButton
			closeButtonPosition="end"
			bodyClassName={infoStyles.drawerBody}
			variant={isMaxSm ? 'fullscreen' : 'side'}
		>
			<div className={infoStyles.content}>
				{content.intro ? <p className={infoStyles.intro}>{content.intro}</p> : null}

				{content.sections?.map((section) => (
					<section key={section.title} className={infoStyles.section}>
						<h3 className={infoStyles.subsectionTitle}>{section.title}</h3>

						{section.heading ? <p className={styles.sectionHeading}>{section.heading}</p> : null}

						{section.text ? <p className={infoStyles.subsectionText}>{section.text}</p> : null}

						{section.steps?.length ? (
							<div className={styles.steps}>
								{section.steps.map((step) => (
									<div key={step.label} className={styles.step}>
										<p className={styles.stepLabel}>{step.label}</p>
										<p className={styles.sectionHeading}>{step.title}</p>
										<p className={infoStyles.subsectionText}>{step.text}</p>
										{step.action ? (
											<RegistrationButton
												variant="muted"
												onClick={() => openExternal(step.action!.url)}
											>
												{step.action.label}
											</RegistrationButton>
										) : null}
									</div>
								))}
							</div>
						) : null}
					</section>
				))}

				{content.action ? (
					<div className={styles.actions}>
						<RegistrationButton variant="muted" onClick={() => openExternal(content.action!.url)}>
							{content.action.label}
						</RegistrationButton>
					</div>
				) : null}
			</div>
		</Drawer>
	);
};
